//TODO looks cool... use this for something... https://github.com/knledg/react-webpack-skeleton

import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import CONFIG from './config';

import 'bootstrap/dist/css/bootstrap.min.css';
import './BootstrapColorOverride.css';
import './vendor/fontawesome/css/all.css';
import './App.css';

import Navigation from './components/Navigation';
import Footer from './components/Footer';

const routes = {
    [CONFIG.ROUTES.HOME]: lazy(() => import('./routes/Home')),
    [CONFIG.ROUTES.ABOUT]: lazy(() => import('./routes/About')),
    [CONFIG.ROUTES.NEWS]: lazy(() => import('./routes/News')),
    [CONFIG.ROUTES.PROJECTS]: lazy(() => import('./routes/Projects')),
    [CONFIG.ROUTES.CONTACT]: lazy(() => import('./routes/Contact')),

    [CONFIG.ROUTES.FAQ]: lazy(() => import('./routes/FAQ')),
    [CONFIG.ROUTES.IMPRINT]: lazy(() => import('./routes/Imprint')),
    [CONFIG.ROUTES.SITEMAP]: lazy(() => import('./routes/Sitemap'))
};

const App = () => (
    <Router>
        <Navigation />
        <Suspense fallback={<div> </div>}>
            <Switch>
                {Object.entries(routes).map(entry => <Route key={entry[0]} exact path={entry[0]} component={entry[1]}/>)}
            </Switch>
        </Suspense>
        <Footer />
    </Router>
);

export default App;
